import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../websitecomponents/redux/EndPoint/endpoint";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const EditProfile = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    shopName: "",
    businessAddress: "",
    gstNumber: "",
    bankDetails: {
      holderName: "",
      accountNumber: "",
      ifscCode: "",
      bankName: "",
    },
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const token = localStorage.getItem("SellerTokenData");
    if (!token) return;

    try {
      setLoading(true);
      const res = await axios.get(endPoint.SellerProfile, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setFormData(res.data.seller);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      ["holderName", "accountNumber", "ifscCode", "bankName"].includes(name)
    ) {
      setFormData((prev) => ({
        ...prev,
        bankDetails: {
          ...prev.bankDetails,
          [name]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("SellerTokenData");
    if (!token) return;

    const payload = {
      fullName: formData.fullName,
      phone: formData.phone,
      shopName: formData.shopName,
      businessAddress: formData.businessAddress,
      bankDetails: {
        accountNumber: formData.bankDetails?.accountNumber || "",
        ifscCode: formData.bankDetails?.ifscCode || "",
        bankName: formData.bankDetails?.bankName || "",
        holderName: formData.bankDetails?.holderName || "",
      },
    };
    try {
      setLoading(true);

      const res = await axios.patch(endPoint.SellerUpdateProfile, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Profile updated successfully");
      navigate("/seller/profile");
    } catch (error) {
      toast.error("Profile update failed");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="px-6 py-6 text-base">Loading profile...</p>;
  }

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
      <h2 className="text-xl sm:text-2xl font-semibold mb-6">
        Edit Seller Profile
      </h2>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6"
      >
        {/* Basic Details */}
        <Input
          label="Full Name"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
        />
        <Input
          label="Phone Number"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />
        <Input
          label="Shop Name"
          name="shopName"
          value={formData.shopName}
          onChange={handleChange}
        />
        <Input
          label="GST Number"
          name="gstNumber"
          value={formData.gstNumber}
          onChange={handleChange}
        />

        <div className="md:col-span-2">
          <Input
            label="Business Address"
            name="businessAddress"
            value={formData.businessAddress}
            onChange={handleChange}
          />
        </div>

        {/* Bank Details */}
        <h3 className="md:col-span-2 text-lg font-semibold mt-8">
          Bank Account Details
        </h3>

        <Input
          label="Account Holder Name"
          name="holderName"
          value={formData.bankDetails?.holderName}
          onChange={handleChange}
        />
        <Input
          label="Account Number"
          name="accountNumber"
          value={formData.bankDetails?.accountNumber}
          onChange={handleChange}
        />
        <Input
          label="IFSC Code"
          name="ifscCode"
          value={formData.bankDetails?.ifscCode}
          onChange={handleChange}
        />
        <Input
          label="Bank Name"
          name="bankName"
          value={formData.bankDetails?.bankName}
          onChange={handleChange}
        />
        <div className="md:col-span-2 flex flex-col sm:flex-row gap-4 mt-6">
          <button
            type="submit"
            className="px-6 py-3 bg-orange-600 text-white text-base rounded-lg hover:bg-blue-700"
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>

          <button
            type="button"
            className="px-6 py-3 border text-base rounded-lg text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

/* 🔹 Reusable Input */
const Input = ({ label, name, value, onChange }) => (
  <div>
    <p className="text-sm sm:text-base text-gray-500 mb-1">{label}</p>
    <input
      type="text"
      name={name}
      value={value || ""}
      onChange={onChange}
      className="w-full border-b border-gray-300 py-2 text-base focus:outline-none focus:border-blue-600"
    />
  </div>
);

export default EditProfile;
